import { useTranslation } from 'react-i18next'
import './styles.scss'
import React, { useEffect, useState } from 'react'
import Checkbox from '../../../../Shared/Form/Checkbox'
import { isRoomImage } from '../../ImageBrowser/utils'
import RoomRow from './RoomRow'
import activityTrackingService from '../../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../../constants'
import DeleteRoomModal from '../DeleteRoomModal'
import PageHead from '../../../../Shared/PageHead'
import Button from '../../../../Shared/Form/Button'
import PublishAllButton from '../../PublishAllButton'

const RoomList = ({
                    property,
                    rooms,
                    roomAttributes,
                    images,
                    onCreateRoomClick,
                    onRoomSelected,
                    onRoomRemoved,
                    onImagesChange,
                    hidden,
                    uploadQueue,
                    onUploadFiles,
                    onUploadQueueImageRemove,
                  }) => {
  const { t } = useTranslation()
  const [roomImagesMap, setRoomImagesMap] = useState({})
  const [showCodes, setShowCodes] = useState(false)
  const [expandedRoomsMap, setExpandedRoomsMap] = useState(new Map())
  const [isAllExpanded, setIsAllExpanded] = useState(false)
  const [roomToDelete, setRoomToDelete] = useState(null)

  const buildRoomImagesMap = (images) => {
    return images.reduce((map, image) => {
      if (isRoomImage(image)) {
        image.rooms.forEach((roomId) => {
          if (!map.hasOwnProperty(roomId)) {
            map[roomId] = []
          }
          map[roomId].push(image)
        })
      }
      return map
    }, {})
  }

  const onShowCodesToggle = () => {
    activityTrackingService.trackEvent(trackingEvent.clickShowCodes)
    setShowCodes((prevShowCodes) => !prevShowCodes)
  }

  const onExpandToggle = (room) => {
    setExpandedRoomsMap((prevExpandedRoomsMap) => {
      const newExpandedRoomsMap = new Map(prevExpandedRoomsMap)
      newExpandedRoomsMap.set(room.id, !newExpandedRoomsMap.get(room.id))
      return newExpandedRoomsMap
    })
  }

  const onExpandAllToggle = () => {
    setExpandedRoomsMap((prevExpandedRoomsMap) => {
      const newExpandedRoomsMap = new Map()
      rooms.forEach((room) => {
        newExpandedRoomsMap.set(room.id, !isAllExpanded)
      })
      setIsAllExpanded((prevIsAllExpanded) => !prevIsAllExpanded)
      return newExpandedRoomsMap
    })
  }

  const cancelRoomDelete = () => {
    setRoomToDelete(null)
  }

  const onRoomDeleteClick = (room) => {
    setRoomToDelete(room)
  }

  useEffect(() => {
    setRoomImagesMap(
      buildRoomImagesMap(images)
    )
  }, [rooms, images])

  if (hidden) {
    return null
  }
  return (
    <div className={'room-list-container'}>
      <div className={'room-list'}>
        <div className={'room-list-header-container'}>
          <PageHead
            title={t('ROOM_TYPES')}
            subtitle={t('ROOM_LIST_DESCRIPTION')}
          >
            <Button
              onClick={onCreateRoomClick}
              classNames={'Button-Primary'}
            >
              {t('CREATE_ROOM')}
            </Button>
            <PublishAllButton giataId={property.giataId}/>
          </PageHead>
        </div>
        {
          rooms.length > 0 && <div className={'room-list-content-container'}>
            <div className={'room-list-content-header'}>
              <div>
                <Checkbox label={t('SHOW_CODES')}
                          onChange={onShowCodesToggle}
                          value={showCodes}/>
                <span className={'room-list-expand-all'}
                      onClick={onExpandAllToggle}>
                                {isAllExpanded ? t('COLLAPSE_ALL') : t('EXPAND_ALL')}
                </span>
              </div>
              <div className={'room-list-spacer'}/>
            </div>
            <div className={'room-list-content'}>
              {
                rooms.map(
                  (room) => <RoomRow
                    key={room.id}
                    room={room}
                    roomAttributes={roomAttributes}
                    roomImages={roomImagesMap[room.id] ?? []}
                    showCodes={showCodes}
                    isExpanded={expandedRoomsMap.get(room.id) ?? false}
                    onExpandToggle={onExpandToggle}
                    onRoomSelected={onRoomSelected}
                    onRoomDeleteClick={onRoomDeleteClick}
                    uploadQueue={uploadQueue.filter(item => item?.roomId === room.id)}
                    onUploadFiles={onUploadFiles}
                    onUploadQueueImageRemove={onUploadQueueImageRemove}
                  />
                )
              }
            </div>
          </div>
        }
      </div>
      {
        roomToDelete &&
        <DeleteRoomModal show={true}
                         giataId={property.giataId}
                         room={roomToDelete}
                         images={images}
                         roomAttributes={roomAttributes}
                         onEscapeKeyDown={cancelRoomDelete}
                         onBackdropClick={cancelRoomDelete}
                         onRoomRemoved={(room) => {
                           onRoomRemoved(room)
                           setRoomToDelete(null)
                         }}
                         onImagesChange={onImagesChange}
                         onCancel={cancelRoomDelete}/>
      }
    </div>
  )
}

export default RoomList
